"use strict";

let addedAllowanceModel = angular.module("addedAllowanceModel", ["familyModel"]);
let addedAllowanceModelFactory = function(ApplicationService, AbstractModelService, FamilyModelFactory,
    CalculationService, $http) {
    let AddedAllowanceModel = function(familyID) {
        this.familyID = familyID;
        this.dataProperty = "addedAllowance";
        this.endpoint = "/addedAllowance";
        this.primaryKey = "recordID";
        this.data = angular.copy(this.get());
    };
    AddedAllowanceModel.prototype = new FamilyModelFactory();
    AddedAllowanceModel.prototype.parent = FamilyModelFactory.prototype;
    AddedAllowanceModel.prototype.new = function() {
        return this.data.push(
            {text: "", amount: ""}
        ) - 1;
    };

    AddedAllowanceModel.prototype.put = function(id, data, instance) {
        let apipath = "/api/family/" + this.familyID + "/addedAllowance/" + data.recordID;
        return AbstractModelService.put(apipath, data, instance);
    };

    AddedAllowanceModel.prototype.post = function(id, data, instance) {
        ApplicationService.getFamilyData().addedAllowance.push(data);
        let apipath = "/api/family/" + this.familyID + "/addedAllowance";
        return AbstractModelService.post(apipath, data, instance);
    };

    AddedAllowanceModel.prototype.purge = function(id, data, instance) {
        let apipath = "/api/family/" + this.familyID + "/addedAllowance/" + data.recordID;
        let ret = AbstractModelService.purge(apipath, data, instance).then(() => {
            $http.get("/api/family/" + this.familyID + "/addedAllowance").then((results) => {
                ApplicationService.getFamilyData().addedAllowance = results.data;
                CalculationService.reCalc();
            });
        });
        return ret;
    };

    AddedAllowanceModel.prototype.updateData = function() { // Abstract
        let familyIndex = ApplicationService.getFamilyIndex(this.familyID);
        if (!ApplicationService.isFamilyTwoSituation()) {
            ApplicationService.getAwardData().family[familyIndex][this.dataProperty] = angular.copy(this.data);
        } else if (ApplicationService.getAwardData().family[familyIndex].data[0].familyID === this.familyID) {
            ApplicationService.getAwardData().family[familyIndex][this.dataProperty] = angular.copy(this.data);
        } else {
            ApplicationService.getAwardData().family[familyIndex][this.dataProperty] = angular.copy(this.data);
        }

        this.data = angular.copy(this.get());
    };

    AddedAllowanceModel.prototype.getCopy = function() {
        return this.data;
    };

    AddedAllowanceModel.prototype.getById = function(id) {
        let items = this.get();
        for (let i = 0; i < items.length; i++) {
            if (items[i][this.primaryKey] == id) {
                return items[i];
            }
        }
        return null;
    };

    AddedAllowanceModel.prototype.purgeAll = function(id, data, instance) {
        let familyIndex = ApplicationService.getFamilyIndex(id);
        for (let i = 0; i < this.data.length; i++) {
            this.purge(id, this.data[i]);
        }

        ApplicationService.getAwardData().family[familyIndex][this.dataProperty] = [];
        this.data = [];
        CalculationService.reCalc();
    };
    return AddedAllowanceModel;
};

addedAllowanceModel.factory("AddedAllowanceModelFactory", addedAllowanceModelFactory);
